//Comentario necesario para codificación en UTF-8, ver Inc6743
(function () {
	angular.module('pphhApp')
	.controller("pphhNavActivityTransitionController", [ "$scope", "$mdDialog", "CRUDService", "instanceData", "action", ActivityTransitionController]);
	
	function ActivityTransitionController($scope, $mdDialog, crudService, instanceData, action) {
		
		var transitionResponse = null;
		
		$scope.action = action;
		
		$scope.confirmPhase = true;
		$scope.transitionFinished = false;
		$scope.background = false;
		
		$scope.cancel = cancel;
		$scope.performTransition = performTransition;
		$scope.quitActivity = quitActivity;
		$scope.notificationText = '';
		
		function cancel() {
			$mdDialog.cancel();
		}
		
		function performTransition() {
			$scope.confirmPhase = false;
			if(confirmTransitionForm.notificationTextId !== undefined)
				$scope.notificationText = confirmTransitionForm.notificationTextId.value;

			crudService.transition(instanceData.entityName, instanceData.id, action.id, $scope.notificationText)
			.then(transitionSuccessCallback, transitionErrorCallback);
		}
		
		function transitionSuccessCallback(response) {
			transitionResponse = response.data;
			
			if(!transitionResponse.background) {
				$mdDialog.hide({redirect: transitionResponse.redirect})
			} else {
				$scope.background = true;
			}
		}

		function transitionErrorCallback(response) {
			$scope.transitionFinished = true;
			
			var errorMessages = [];
			
			if(response.status === 409) {
				errorMessages = response.data;
			} else {
				errorMessages.push({
					failure: true,
					message: "Error transitioning"
				});
			}
			
			$mdDialog.cancel(errorMessages);
		}
		
		function quitActivity() {
			$mdDialog.hide({redirect: transitionResponse.redirect})
		}
	}
})();